import { FormGroup, ListSubheader, useTheme } from '@mui/material';
import Checkbox from 'components/checkbox';
import FlexBox from 'components/flex-box';
import Switch from 'components/switch';
import TextField from 'components/text-field';
import { Search } from 'lucide-react';
import { useIntl } from 'react-intl';

type SubheaderExtProps =
  | {
      toggle?: { label: string; value: boolean; onChange: (value: boolean) => void };
      checkAll: { value: boolean; onChange: () => void };
    }
  | {
      toggle?: { label: string; value: boolean; onChange: (value: boolean) => void };
      checkAll?: { value: boolean; onChange: () => void };
    };

type SubheaderProps = SubheaderExtProps & {
  search?: { value: string; onChange: (event: any) => void };
  action?: React.ReactNode;
};

const Subheader: React.FC<SubheaderProps> = ({ toggle, search, checkAll, action }) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <ListSubheader sx={{ position: checkAll ? 'relative' : 'sticky', padding: 2 }}>
      <FlexBox gap={4}>
        {action && action}
        {search && (
          <TextField
            autoFocus
            dark
            hiddenLabel
            stopPropagation
            fullWidth
            label="Search"
            size="small"
            placeholder={intl.formatMessage({ id: 'general.search' })}
            value={search.value}
            endAdornment={<Search size={18} />} 
            onChange={(event) => {
              search.onChange(event.target.value);
            }}
            onKeyDown={(event) => {
              event.key !== 'Escape' && event.stopPropagation();
            }}
          />
        )}
        {checkAll ? (
          <FormGroup>
            <Checkbox
              dark
              checked={checkAll.value}
              label={intl.formatMessage({ id: 'general.checkAll' })}
              onChange={() => checkAll.onChange()}
            />
          </FormGroup>
        ) : toggle ? (
          <Switch label={toggle.label} dark value={toggle.value} onChange={() => toggle.onChange(!toggle.value)} />
        ) : null}
      </FlexBox>
    </ListSubheader>
  );
};

export default Subheader;
